import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/pagination';
import { Box } from '@mui/material';
import MobileCardItem from './mobileCardItem';

const MobileSpacesList = ({
  spaces,
  setSelectedSpace,
  startDate,
  endDate,
  setHoveredMarkerId,
  moveMapToLocation, // Method to move the map
  onDetailClick,
  swiperRef, // Receive swiperRef from parent
}) => {

  
  // Function to move the carousel to a specific slide
  const moveToSlide = (slug) => {
    const slideIndex = spaces?.findIndex((space) => space.slug === slug);
    if (swiperRef.current && slideIndex !== -1) {
      swiperRef.current.slideTo(slideIndex, 500); // Use the Swiper instance to slide
    } else {
      console.warn('Swiper instance not ready or slide not found.');
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: '190px',
        backgroundColor: 'white',
        boxShadow: '0px -4px 10px rgba(0, 0, 0, 0.1)',
        '.swiper': {
          width: '100%',
          height: '100%',
          padding: '16px',
        },
        '.swiper-slide': {
          width: 'auto',
          height: '100%',
        },
        '.swiper-pagination': {
          bottom: '0px',
        },
      }}
    >
      <Swiper
        onSwiper={(swiperInstance) => {
          swiperRef.current = swiperInstance; // Capture the Swiper instance
        }}
        modules={[FreeMode, Pagination]}
        slidesPerView="auto"
        spaceBetween={16}
        freeMode={{
          enabled: true,
          sticky: false,
        }}
        pagination={{
          clickable: true,
          dynamicBullets: true,
        }}
        onSlideChange={(swiper) => {
          const currentSpace = spaces[swiper.activeIndex];
          if (currentSpace?.venue_location) {
            //isManualPan.current = true;
            moveMapToLocation({
              lat: currentSpace.venue_location[1],
              lng: currentSpace.venue_location[0],
            });
          }
        }}
      >
        {spaces?.map((space) => (
          <SwiperSlide key={space.slug}>
            <Box
              sx={{
                width: '80vw',
                maxWidth: '400px',
                height: '100%',
              }}
            >
              <MobileCardItem
                space={space}
                setSelectedSpace={(selectedSpace) => {
                  setSelectedSpace(selectedSpace);
                  moveToSlide(selectedSpace.slug); // Move carousel to the selected item
                }}
                startDate={startDate}
                endDate={endDate}
                onDetailClick={(space,date) => onDetailClick(space,date)}
                onMouseEnter={() => {
                  setHoveredMarkerId(space.slug);
                  if (space.venue_location) {
                    //isManualPan.current = true;
                    moveMapToLocation({
                      lat: space.venue_location[1],
                      lng: space.venue_location[0],
                    });
                  }
                }}
                onMouseLeave={() => setHoveredMarkerId(null)}
              />
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};

export default MobileSpacesList;
